import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { FixedAsset, FixedAssetDTO } from '../../../../core/models/fixedasset.interface';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../../core/services/loading/loading';
import { FixedassetService } from '../../../../core/services/fixedasset/fixedasset-service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormUtils } from '../../../../shared/utils';
import { TermPipe } from '../../../../shared/pipes/term.pipe';
import { TermKey } from '../../../../core/models/terminology.interface';

@Component({
  selector: 'app-fixedasset-form',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
    TermPipe,
  ],
  templateUrl: './fixedasset-form.html',
  styleUrl: './fixedasset-form.scss',
})
export class FixedassetForm {
  fixedasset: string | null = null;
  errorMsg: string[] | null = null;
  fixedassetSelected: FixedAsset | null = null;
  private formBuilder = inject(FormBuilder);
  termKey = TermKey;

  constructor(
    private dialogRef: MatDialogRef<FixedassetForm>,
    private toastr: ToastrService,
    private fixedAssetService: FixedassetService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.fetchFixedAsset();
    this.fixedAssetService.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });
  }

  private fetchFixedAsset() {
    this.fixedAssetService.selectedFixedAsset$.subscribe((fixedAsset) => {
      if (fixedAsset) {
        this.fixedasset = String(fixedAsset.id);
        this.fixedassetSelected = fixedAsset;
        this.fixedassetForm.patchValue({
          ...this.fixedassetSelected,
        });
      }
    });
  }

  fixedassetForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(150)]],
    description: ['', []],
    lifetime: [0, []],
  });

  closeDialog() {
    this.dialogRef.close();
  }

  savefixedAsset() {
    const payload = this.fixedassetForm.value as FixedAssetDTO;
    if (this.fixedassetForm.status === 'VALID' && !this.fixedasset) {
      this.loadingService.show(true);
      this.fixedAssetService.createFixedAsset(payload).subscribe({
        next: (fixedAsset) => {
          this.loadingService.show(false);
          const msg = `El activo fijo ${fixedAsset.name} fue CREADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    } else if (this.fixedassetForm.status === 'VALID' && this.fixedasset) {
      this.loadingService.show(true);
      const id = Number(this.fixedasset);
      this.fixedAssetService.UpdateFixedAsset(id, { ...payload, id: id }).subscribe({
        next: (fixedAsset) => {
          this.loadingService.show(false);
          const msg = `El activo fijo ${fixedAsset.name} fue EDITADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    }
  }
}
